import React from 'react';

const CloseModalDarkIcon = () => {

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="10" fill="#34435A"/>
      <path
        d="M13.8594 13.1953L10.6625 10.0002L13.8594 6.82857C14.0196 6.64301 14.0109 6.36455 13.8395 6.18947C13.668 6.01439 13.3916 6.00171 13.2051 6.16037L9.99882 9.30845L6.84867 6.13684C6.66637 5.95439 6.37196 5.95439 6.18966 6.13684C6.10118 6.22519 6.05141 6.34547 6.05141 6.47094C6.05141 6.59641 6.10118 6.71668 6.18966 6.80504L9.33514 9.97195L6.13825 13.1389C6.04977 13.2272 6 13.3475 6 13.473C6 13.5984 6.04977 13.7187 6.13825 13.8071C6.22645 13.8951 6.34586 13.9442 6.47009 13.9435C6.59204 13.9443 6.70945 13.897 6.79726 13.8118L9.99882 10.6354L13.2051 13.8635C13.2933 13.9516 13.4127 14.0007 13.5369 14C13.6595 13.9995 13.777 13.9505 13.8641 13.8635C13.9519 13.7745 14.0009 13.6539 14 13.5284C13.9991 13.403 13.9485 13.2831 13.8594 13.1953Z"
        fill="#ABB9C6"
      />
    </svg>

  );
};

export default CloseModalDarkIcon;
